// Dumb dialog — no store, no analytics, no API.
//
//   props:  modelValue         (Boolean)  v-model for the open state
//           projectName        (String)   '' while still unknown -> hero spinner
//           initializing       (Boolean)  DuckDB not ready yet -> Load button disabled
//           dataLoaded         (Boolean)  drives :persistent
//           apiProgress        (Number)   requests completed
//           totalApiRequests   (Number)   requests expected
//           queryString        (String)   copied by the dev-mode double-click
//           heroImage          (String)   hero background URL; defaults to the packaged one
//           showMarketingPanel (Boolean)  opt-in "Discover what's new from RDrive" panel under
//                                         the hero (cards + rdrive.io item pages). Off (the
//                                         default) renders the hero alone, exactly as before
//                                         the panel existed: no iframes, no images, no listener.
//           contained          (Boolean)  true (the default): centre in the page container,
//                                         below the app bar (README "Centring"); false: centre
//                                         on the viewport, for an app whose pre-load page is
//                                         taller than the viewport.
//   emits:  update:modelValue           open/close
//           load                        the Load Dashboard button was pressed
//           copyQueryString             the title was double-clicked (parent tracks it;
//                                       this component still does the clipboard write)
//           marketingItemOpen           a panel card was clicked: { id, url }
//           marketingItemVisit          a navigation inside an item page opened its real
//                                       page in a new tab: { id, url, targetUrl }
//
// Strings come from the colocated ./messages folder through a LOCAL composer (rule 11);
// see ./setup.js. The hero font ('sofia-pro-variable') is an APP prerequisite — see
// packages/rdrive-plugin-welcome-dialog/README.md.
// A JS asset import, not a CSS url(): Vite rewrites it for both dev (/@fs/… real path
// under pnpm) and build (build.assetsDir), and it makes the image overridable per app.
import defaultHero from './assets/background.png';
import setup from './setup.js';

export default {
  name: 'welcome-dialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    projectName: {
      type: String,
      default: ''
    },
    initializing: {
      type: Boolean,
      default: true
    },
    dataLoaded: {
      type: Boolean,
      default: false
    },
    apiProgress: {
      type: Number,
      required: true
    },
    totalApiRequests: {
      type: Number,
      required: true
    },
    queryString: {
      type: String,
      default: ''
    },
    heroImage: {
      type: String,
      default: defaultHero
    },
    showMarketingPanel: {
      type: Boolean,
      default: false
    },
    contained: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'load', 'copyQueryString', 'marketingItemOpen', 'marketingItemVisit'],
  setup,
};
